/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEventoPayload } from './pratica-evento-payload';


export interface OtpPayload extends PraticaEventoPayload { 
    canale?: OtpPayloadCanaleEnum;
    destinatario_mascherato?: string;
    tentativo_numero?: number;
}
export enum OtpPayloadCanaleEnum {
    SMS = 'SMS',
    EMAIL = 'EMAIL',
    WA = 'WA'
};



